import Loading from '@/components/shared/Loading';
import Seo from '@/components/shared/Seo';
import { useSession } from '@/contexts/LitSessionProvider';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
import classNames from '@/lib/misc/classNames';
import { baseUrl } from '@/lib/misc/const';
import { useMixpanel } from '@/lib/misc/mixpanel';
import { useTheme } from 'next-themes';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
const onramperPaymentMethods = {
  apple: 'applepay',
  google: 'googlepay',
  card: 'creditcard',
  bank: 'banktransfer'
};
export default function OnramperDeposit({
  amount,
  onlyAllowStripe,
  paymentMethod
}) {
  const {
    PKP
  } = useSession();
  const {
    theme
  } = useTheme();
  const router = useRouter();
  const isMobile = useIsMobile();
  const {
    containerColor,
    cardColor,
    secondaryColor,
    primaryColor
  } = onramperColors(theme);
  const {
    LogToMixpanel,
    EVENTS,
    CATEGORIES
  } = useMixpanel();
  const url = `https://buy.onramper.com?apiKey=pk_prod_01J09Q61JSG3A6THMBRVHGD9FH&mode=buy&themeName=${theme === 'dark' ? 'dark' : 'light'}&containerColor=${containerColor}&borderRadius=0.5&wgBorderRadius=1&cardColor=${cardColor}&secondaryColor=${secondaryColor}&primaryColor=${primaryColor}&onlyCryptos=sol&wallets=sol:${PKP?.solanaAddress}&successRedirectUrl=www.tradegenius.com%2Fhome%3Fmessage%3D'Your%20deposit%20was%20a%20success.%20Please%20allow%20up%20to%205%20minutes%20for%20your%20account%20to%20reflect%20the%20deposit.'&failureRedirectUrl=www.tradegenius.com%2Fhome%3Fmessage%3D'Your%20deposit%20failed.%20Please%20try%20again%20or%20contact%20support.'&mode=buy${onlyAllowStripe ? '&onlyOnramps=stripe' : ''}&defaultCrypto=sol&defaultFiat=usd&defaultAmount=${amount}&onlyCryptoNetworks=solana&defaultPaymentMethod=${onramperPaymentMethods[paymentMethod]}`;

  // const url = `https://buy.onramper.com?apiKey=pk_prod_01J09Q61JSG3A6THMBRVHGD9FH&mode=buy&themeName=${theme === 'dark' ? 'dark' : 'light'}&containerColor=${containerColor}&borderRadius=0.5&wgBorderRadius=1&cardColor=${cardColor}&secondaryColor=${secondaryColor}&primaryColor=${primaryColor}&onlyCryptos=usdc_arbitrum&wallets=usdc_arbitrum:${PKP?.additionalEthAddress}&defaultPaymentMethod=applepay`;

  useEffect(() => {
    LogToMixpanel({
      pkp: PKP,
      eventName: EVENTS.deposit.startDeposit,
      category: CATEGORIES.deposit,
      metaData: {
        type: 'onramper'
      }
    });
  }, []);
  const [loading, setLoading] = useState(true);
  return <div className='h-full w-full  flex items-center justify-center mt-4' data-sentry-component="OnramperDeposit" data-sentry-source-file="onramper.tsx">
      {loading && <div className='h-[630px] flex items-center justify-center'>
          <Loading />
        </div>}
      <iframe onLoad={() => {
      setLoading(false);
    }} src={url} title='Onramper Widget' allow='accelerometer; autoplay; camera; gyroscope; payment; microphone' className={classNames('rounded-xl w-[500px] h-[630px] max-lg:w-10/12', loading ? 'hidden' : 'block')} />
    </div>;
}
export const onramperColors = theme => {
  const containerColor = theme === 'dark' ? '231645' : 'FAF5FF';
  const cardColor = theme === 'dark' ? '09001A' : 'E6DBFF';
  const secondaryColor = theme === 'dark' ? '231645' : 'FAF5FF';
  const primaryColor = 'FF578F';
  return {
    containerColor,
    cardColor,
    secondaryColor,
    primaryColor
  };
};